import {Restaurant} from "../../../models/restaurant";
import {SessionStorage} from "../storage/session-storage";
import {
  RESTAURANT_ID,
  RESTAURANT_LOCATION_DETAILS,
  RESTAURANT_LOCATION_ID,
  RESTAURANT_LOGO,
  RESTAURANT_NAME
} from "../constants/restaurant.storage.const";

export class AppRestaurantState {
  constructor() {}

  get id(): string {
    return SessionStorage.getSessionString(RESTAURANT_ID);
  }

  get name(): string {
    return SessionStorage.getSessionString(RESTAURANT_NAME);
  }

  get logo(): string {
    return SessionStorage.getSessionString(RESTAURANT_LOGO);
  }

  get restaurantId(): string {
    return SessionStorage.getSessionString(RESTAURANT_LOCATION_ID);
  }

  get restaurantDetails(): Restaurant {
    return SessionStorage.getSessionObject(
      RESTAURANT_LOCATION_DETAILS
    );
  }

  set id(id: string) {
    SessionStorage.setSessionString(RESTAURANT_ID, id);
  }

  set name(name: string) {
    SessionStorage.setSessionString(RESTAURANT_NAME, name);
  }

  set logo(logoUrl: string) {
    SessionStorage.setSessionString(RESTAURANT_LOGO, logoUrl);
  }

  set restaurantId(id: string) {
    SessionStorage.setSessionString(RESTAURANT_LOCATION_ID, id);
  }

  set restaurantDetails(value: any) {
    SessionStorage.setSessionObject(
      RESTAURANT_LOCATION_DETAILS,
      value
    );
  }

  public reset() {
    SessionStorage.removeSession(RESTAURANT_ID);
    SessionStorage.removeSession(RESTAURANT_NAME);
    SessionStorage.removeSession(RESTAURANT_LOGO);
    SessionStorage.removeSession(RESTAURANT_LOCATION_ID);
    SessionStorage.removeSession(RESTAURANT_LOCATION_DETAILS);
  }
}
